import React from "react";

const HomeErrorBoundary = () => {
  return (
    <div className="flex flex-col min-h-[60vh] items-center justify-center gap-6 px-4 text-center">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
        <svg
          className="w-8 h-8 text-green-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </div>
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
          Une erreur est survenue pendant le chargement
        </h1>
        <p className="mt-2 text-gray-500">
          Veuillez rafraîchir la page pour réessayer.
        </p>
      </div>
      <button
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-xl transition-colors"
      >
        Rafraîchir la page
      </button>
    </div>
  );
};

export default HomeErrorBoundary;